// const usSubscribeProps = {
//   color_theme: 'DARK',
//   scroll_in_animation: true,
//   region: 'US',
//   expandable: true,
//   title: 'Get the latest news and important updates from FF',
//   form_fields: {
//     email: 'Email Address',
//     first_name: 'First Name',
//     last_name: 'Last Name',
//     zipcode: 'Zipcode',
//     interested_in_reserve: 'I\'m interested in reserving an FF 91',
//     reserve_now: 'Reserve Now',
//     subscribe: 'Subscribe',
//     error_msg: 'Something went wrong. Please try again later.',
//     subscribe_in_china: 'Please subscribe on our China region site.',
//     success_message: 'Your subscription has been confirmed. You’ll receive the latest news and updates from Faraday Future.',
//     continue_to_reserve: 'If you would like to reserve an FF 91 please click the button below.'
//   },
//   redirect_link: '/cn'
// };

const usFooterProps = {
	"footerRegion": "US",
	"regions": [
		{
			"imgUrl": "https://genesis-cdn.ff.com/icon-en.png",
			"value": "US",
			"domain": "https://www.ff.com/us/"
		},
		{
			"imgUrl": "https://genesis-cdn.ff.com/icon-china.png",
			"value": "CN",
			"domain": "https://www.faradayfuturecn.com/cn/"
		}
	],
	"items": [
		{
			"sectionTitle": "ABOUT US",
			"links": [
				{
					"url": "/our-company",
					"label": "Our Company"
				},
				{
					"url": "/our-approach",
					"label": "Our Approach"
				},
				{
					"url": "/our-team",
					"label": "Our Team"
				},
				{
					"url": "/us/co-creation/",
					"label": "Co-Creation"
				},
				{
					"url": "/us/press-room/",
					"label": "Press Room"
				},
				{
					"url": "/us/futuresight/",
					"label": "Blog"
				},
				{
					"url": "/us/solutions/",
					"label": "Solutions"
				},
				{
					"url": "https://investors.ff.com",
					"label": "Investors"
				},
				{
					"url": "/us/ff-zero-1/",
					"label": "FF Zero 1"
				},
				{
					"url": "/us/gallery/",
					"label": "FF Gallery"
				}
			]
		},
		{
			"sectionTitle": "SUPPORT",
			"links": [
				{
					"url": "/us/contact-us/",
					"label": "Contact Us"
				},
				{
					"url": "/us/frequently-asked-questions/",
					"label": "FAQ"
				},
				{
					"url": "/us/careers/",
					"label": "Careers"
				},
				{
					"url": "/us/sitemap/",
					"label": "Sitemap"
				},
				{
					"url": "/us/privacy-policy/",
					"label": "Privacy Policy"
				},
				{
					"url": "/us/terms-of-use/",
					"label": "Terms of Use"
				}
			]
		}
	],
	"socialLinks": [
		{
			"url": "https://www.linkedin.com/company/faradayfuture",
			"icon": "ff-icon-social-linkedin"
		},
		{
			"url": "https://www.youtube.com/c/faradayfuture",
			"icon": "ff-icon-social-youtube"
		},
		{
			"url": "https://twitter.com/faradayfuture?lang=en",
			"icon": "ff-icon-social-twitter"
		},
		{
			"url": "https://www.facebook.com/faradayfuture/",
			"icon": "ff-icon-social-facebook"
		},
		{
			"url": "https://www.instagram.com/faradayfuture/",
			"icon": "ff-icon-social-instagram"
		}
	],
	"copyright": {
		"text": "Faraday&Future Inc. © {year}"
	},
	"download": {
		"url": "https://www.ff.com/us/mobile-app/",
		"title": "DOWNLOAD FF INTELLIGENT APP",
		"appButtonText": "INSTALL APP",
		"iosStoreLink": "https://itunes.apple.com/us/app/id1600637235?ls=1&mt=8",
		"iosAppLink": "https://faradayfuture2023.app.link/YajHk0j7Nxb",
		"iosImage": "",
		"androidStoreLink": "https://play.google.com/store/apps/details?id=com.faradayfuture.online.foreign",
		"androidAppLink": "faradayfuture://feed",
		"androidApkLink": "",
		"androidImage": ""
	},
	"subscribeForm": {
		"enabled": true,
		"submitUrl": "/api/subscribe/",
		"title": "Get the latest news and important updates from FF",
		"subtitle": "Sign up for the latest of the FF 91 Futurist and other news about Faraday Future",
		"inputPlaceholder": "Email Address *",
		"inputErrorMessage": "* Please enter a valid email address",
		"serverErrorMessage": "Something went wrong. Please try again later.",
		"successMessage": "Your subscription has been confirmed. You’ll receive the latest news and updates from Faraday Future.",
		"button": "Subscribe →",
		"margin": "10px 0px"
	},
	"navLinks": [
		{
			"links": [
				{
					"text": "FF EAI-Robotics Home",
					"url": "https://robotics.ff.com/us/"
				},
				{
					"text": "FF Futurist",
					"url": "https://robotics.ff.com/us/ff-futurist/"
				},
				{
					"text": "FF Master",
					"url": "https://robotics.ff.com/us/ff-master/"
				},
				{
					"text": "FX Aegis",
					"url": "https://robotics.ff.com/us/fx-aegis/"
				}
			]
		},
		{
			"links": [
				{
					"text": "Faraday X Home",
					"url": "https://www.ff.com/us/fx/"
				},
				{
					"text": "FX Super One",
					"url": "https://www.ff.com/us/fx/super-one/"
				}
			]
		},
		{
			"links": [
				{
					"text": "FF 91 2.0 Futurist Alliance",
					"url": "https://www.ff.com/us/product/ff-91-Alliance/"
				},
				{
					"text": "FF 91 2.0 Futurist ",
					"url": "https://www.ff.com/us/product/ff-91-Futurist/"
				},
				{
					"text": "FF 91 2.0",
					"url": "https://www.ff.com/us/preorder/ff-91"
				},
				{
					"text": "FF aiHypercar+",
					"url": "https://www.ff.com/us/ecosystem-product"
				}
			]
		},
		{
			"links": [
				{
					"text": "FF aiHyper 6x4 Architecture 2.0",
					"url": "https://www.ff.com/us/aihyper-architecture/"
				},
				{
					"text": "All-Ability aiHypercar",
					"url": "https://www.ff.com/us/all-ability-aihypercar/"
				},
				{
					"text": "FF Labs",
					"url": "https://www.ff.com/us/ff-labs/"
				},
				{
					"text": "FF Open Platform",
					"url": "https://open.ff.com/"
				}
			]
		},
		{
			"links": [
				{
					"text": "Live & Event",
					"url": "https://www.ff.com/us/live-and-events/"
				},
				{
					"text": "Press Room",
					"url": "https://www.ff.com/us/press-room-new/"
				},
				{
					"text": "Investor Relations",
					"url": "https://investors.ff.com/"
				},
				{
					"text": "Get Updates",
					"url": "https://www.ff.com/us/newsletter-subscribe/"
				}
			]
		},
		{
			"links": [
				{
					"text": "AIxC",
					"url": "https://www.aixcrypto.ai/en/",
					"prompt": {
						"title": "You're now leaving the FFAI website.",
						"message": "You are about to visit a website independently operated by AIXC and subject to its own terms and privacy policies. FFAI does not endorse or control the content of AIXC's website and is not liable for the content, accuracy, or practices of AIXC's website.",
						"actionText": "Proceed to AIXC",
						"cancelText": "Stay Here"
					}
				},
				{
					"text": "C10 Index",
					"url": "https://www.aixcrypto.ai/en/c10index/",
					"prompt": {
						"title": "You're now leaving the FFAI website.",
						"message": "You are about to visit a website independently operated by AIXC and subject to its own terms and privacy policies. FFAI does not endorse or control the content of AIXC's website and is not liable for the content, accuracy, or practices of AIXC's website.",
						"actionText": "Proceed to AIXC",
						"cancelText": "Stay Here"
					}
				},
				{
					"text": "C10 Treasury",
					"url": "https://www.aixcrypto.ai/en/c10treasury/",
					"prompt": {
						"title": "You're now leaving the FFAI website.",
						"message": "You are about to visit a website independently operated by AIXC and subject to its own terms and privacy policies. FFAI does not endorse or control the content of AIXC's website and is not liable for the content, accuracy, or practices of AIXC's website.",
						"actionText": "Proceed to AIXC",
						"cancelText": "Stay Here"
					}
				}
			]
		},
		{
			"links": [
				{
					"text": "Charging",
					"url": "https://www.ff.com/us/charging/"
				},
				{
					"text": "Service",
					"url": "https://www.ff.com/us/service/"
				},
				{
					"text": "FF Shop",
					"url": "https://shop.ff.com/"
				}
			]
		},
		{
			"links": [
				{
					"text": "Contact Us",
					"url": "https://www.ff.com/us/contact-us/"
				},
				{
					"text": "My Account",
					"url": "https://www.ff.com/us/MyFF"
				}
			]
		}
	],
	"extraLinks": [
		{
			"text": "Privacy & Legal",
			"url": "/us/privacy-policy/"
		},
		{
			"text": "About Us",
			"url": "/us/our-company/"
		},
		{
			"text": "Our Team",
			"url": "/us/our-team/"
		},
		{
			"text": "Careers",
			"url": "/us/careers/"
		},
		{
			"text": "Terms of Use",
			"url": "/us/terms-of-use/"
		}
	],
	"regionsV4": [
		{
			"country": "United States(English)",
			"code": "US",
			"language": "English",
			"url": "https://www.ff.com/us/"
		},
		{
			"country": "中国大陆(简体中文)",
			"code": "CN",
			"language": "中文",
			"url": "https://www.faradayfuturecn.com/cn/"
		},
		{
			"code": "AR",
			"url": "https://www.ff.com/ar/",
			"country": "UAE(اَلْعَرَبِيَّةُ)",
			"language": "اَلْعَرَبِيَّةُ"
		},
		{
			"code": "AR_EN",
			"url": "https://www.ff.com/ar/en/",
			"country": "UAE(English)",
			"language": "English"
		}
	],
	"version": "4"
};

// AE English footer props
const aeEnFooterProps = {
  footerRegion: "AR_EN",
  dir: "ltr", // Add LTR direction for English
  regions: [
    {
      imgUrl: "https://genesis-cdn.ff.com/icon-en.png",
      value: "US",
      domain: ""
    },
    {
      imgUrl: "https://genesis-cdn.ff.com/icon-china.png",
      value: "CN",
      domain: ""
    }
  ],
  items: [
    {
      sectionTitle: "Faraday Future Home",
      links: [
        {
          url: "/our-company",
          label: "Our Company"
        },
        {
          url: "/our-approach",
          label: "Our Approach"
        },
        {
          url: "/our-team",
          label: "Our Team"
        },
        {
          url: "/press-room",
          label: "Press Room"
        },
        {
          url: "/futuresight",
          label: "Blog"
        },
        {
          url: "/ff-zero-1",
          label: "FF Zero 1"
        },
        {
          url: "/gallery",
          label: "FF Gallery"
        },
        {
          url: "/solutions",
          label: "Solutions"
        },
        {
          url: "https://investors.ff.com",
          label: "Investors"
        }
      ]
    },
    {
      sectionTitle: "SUPPORT",
      links: [
        {
          url: "/contact-us",
          label: "Contact Us"
        },
        {
          url: "/frequently-asked-questions",
          label: "FAQ"
        },
        {
          url: "/careers",
          label: "Careers"
        },
        {
          url: "/sitemap",
          label: "Sitemap"
        },
        {
          url: "/privacy-policy",
          label: "Privacy Policy"
        },
        {
          url: "/terms-of-use",
          label: "Terms of Use"
        }
      ]
    }
  ],
  socialLinks: [
    {
      url: "https://www.linkedin.com/company/faradayfuture",
      icon: "ff-icon-social-linkedin"
    },
    {
      url: "https://www.youtube.com/c/faradayfuture",
      icon: "ff-icon-social-youtube"
    },
    {
      url: "https://twitter.com/faradayfuture?lang=en",
      icon: "ff-icon-social-twitter"
    },
    {
      url: "https://www.facebook.com/faradayfuture/",
      icon: "ff-icon-social-facebook"
    },
    {
      url: "https://www.instagram.com/faradayfuture/",
      icon: "ff-icon-social-instagram"
    }
  ],
  copyright: {
    text: "Faraday&Future Inc. © {year}"
  },
  download: {
    url: "https://www.ff.com/us/mobile-app",
    title: "DOWNLOAD FF INTELLIGENT APP",
    appButtonText: "INSTALL APP",
    iosStoreLink: "https://itunes.apple.com/us/app/id1600637235?ls=1&mt=8",
    iosAppLink: "https://faradayfuture2023.app.link/YajHk0j7Nxb",
    iosImage: "",
    androidStoreLink: "https://play.google.com/store/apps/details?id=com.faradayfuture.online.foreign",
    androidAppLink: "faradayfuture://feed",
    androidApkLink: "",
    androidImage: ""
  },
  subscribeForm: {
    enabled: true,
    submitUrl: "/api/subscribe/",
    title: "Get the latest news and important updates from FF",
    subtitle: "Sign up for the latest of the FF 91 Futurist and other news about Faraday Future",
    inputPlaceholder: "Email*",
    inputErrorMessage: "Please provider a valid email",
    serverErrorMessage: "Something went wrong. Please try again later.",
    successMessage: "Your subscription has been confirmed. You'll receive the latest news and updates from Faraday Future.",
    button: "Subscribe →",
    margin: "10px 0px"
  },
  navLinks: [
    {
      links: [
        {
          text: "Faraday X Home",
          url: "/ae_en/fx/"
        },
        {
          text: "FX Super One",
          url: "/ae_en/fx/super-one"
        }
      ]
    },
    {
      links: [
        {
          text: "Faraday Future Home",
          url: "/ae_en/"
        },
        {
          text: "FF 91 2.0 Futurist aiFalcon",
          url: "/ar/en/product/ff-91-aiFalcon/"
        },
        {
          text: "FF aiHyper 6x4 Architecture 2.0",
          url: "/ar/en/aihyper-architecture/"
        },
        {
          text: "About Us",
          url: "/ar/en/our-company/"
        }
      ]
    },
    {
      links: [
        {
          text: "Co-Creation",
          url: "/ar/en/ff-co-creation-and-co-sharing/"
        },
        {
          text: "Live & Events",
          url: "/ar/en/live-and-events/"
        },
        {
          text: "Investor Relations",
          url: "https://investors.ff.com/"
        }
      ]
    }
  ],
  extraLinks: [],
  regionsV4: [
    {
      country: "United States",
      code: "US",
      language: "English",
      url: "https://www.ff.com/us/"
    },
    {
      country: "中国大陆",
      code: "CN",
      language: "简体中文",
      url: "https://www.faradayfuturecn.com/cn/"
    },
    {
      code: "AR",
      url: "https://www.ff.com/ar/",
      country: "UAE(اَلْعَرَبِيَّةُ)",
      language: "اَلْعَرَبِيَّةُ"
    },
    {
      code: "AR_EN",
      url: "https://www.ff.com/ar/en/",
      country: "UAE(English)",
      language: "English"
    }
  ],
  version: "4"
};

// AE Arabic footer props
const aeArFooterProps = {
  footerRegion: "AR",
  dir: "rtl", // Add RTL direction for Arabic
  regions: [
    {
      imgUrl: "https://genesis-cdn.ff.com/icon-en.png",
      value: "US",
      domain: ""
    },
    {
      imgUrl: "https://genesis-cdn.ff.com/icon-china.png",
      value: "CN",
      domain: ""
    }
  ],
  items: [
    {
      sectionTitle: "ABOUT US",
      links: [
        {
          url: "/our-company",
          label: "Our Company"
        },
        {
          url: "/our-approach",
          label: "Our Approach"
        },
        {
          url: "/our-team",
          label: "Our Team"
        },
        {
          url: "/press-room",
          label: "Press Room"
        },
        {
          url: "/futuresight",
          label: "Blog"
        },
        {
          url: "/ff-zero-1",
          label: "FF Zero 1"
        },
        {
          url: "/gallery",
          label: "FF Gallery"
        },
        {
          url: "/solutions",
          label: "Solutions"
        },
        {
          url: "https://investors.ff.com",
          label: "Investors"
        }
      ]
    },
    {
      sectionTitle: "SUPPORT",
      links: [
        {
          url: "/contact-us",
          label: "Contact Us"
        },
        {
          url: "/frequently-asked-questions",
          label: "FAQ"
        },
        {
          url: "/careers",
          label: "Careers"
        },
        {
          url: "/sitemap",
          label: "Sitemap"
        },
        {
          url: "/privacy-policy",
          label: "Privacy Policy"
        },
        {
          url: "/terms-of-use",
          label: "Terms of Use"
        }
      ]
    }
  ],
  socialLinks: [
    {
      url: "https://www.linkedin.com/company/faradayfuture",
      icon: "ff-icon-social-linkedin"
    },
    {
      url: "https://www.youtube.com/c/faradayfuture",
      icon: "ff-icon-social-youtube"
    },
    {
      url: "https://twitter.com/faradayfuture?lang=en",
      icon: "ff-icon-social-twitter"
    },
    {
      url: "https://www.facebook.com/faradayfuture/",
      icon: "ff-icon-social-facebook"
    },
    {
      url: "https://www.instagram.com/faradayfuture/",
      icon: "ff-icon-social-instagram"
    }
  ],
  copyright: {
    text: "Faraday&Future Inc. © {year}"
  },
  download: {
    url: "https://www.ff.com/us/mobile-app",
    title: "DOWNLOAD FF INTELLIGENT APP",
    appButtonText: "INSTALL APP",
    iosStoreLink: "https://itunes.apple.com/us/app/id1600637235?ls=1&mt=8",
    iosAppLink: "https://faradayfuture2023.app.link/YajHk0j7Nxb",
    iosImage: "",
    androidStoreLink: "https://play.google.com/store/apps/details?id=com.faradayfuture.online.foreign",
    androidAppLink: "faradayfuture://feed",
    androidApkLink: "",
    androidImage: ""
  },
  subscribeForm: {
    enabled: true,
    submitUrl: "/api/subscribe/",
    title: "Get the latest news and important updates from FF",
    subtitle: "Sign up for the latest of the FF 91 Futurist and other news about Faraday Future",
    inputPlaceholder: "Email*",
    inputErrorMessage: "Please provider a valid email",
    serverErrorMessage: "Something went wrong. Please try again later.",
    successMessage: "Your subscription has been confirmed. You'll receive the latest news and updates from Faraday Future.",
    button: "Subscribe →",
    margin: "10px 0px"
  },
  navLinks: [
    {
      links: [
        {
          text: "Faraday X الرئيسية",
          url: "/ae_ar/fx/"
        },
        {
          text: "FX Super One",
          url: "/ae_ar/fx/super-one"
        }
      ]
    },
    {
      links: [
        {
          text: "Faraday Future  الرئيسية",
          url: "/ae_ar/"
        },
        {
          text: "سيارة FF 91 2.0 Futurist aiFalcon",
          url: "/ar/product/ff-91-aiFalcon/"
        },
        {
          text: "تكنولوجيا FF aiHyper 6x4 Architecture 2.0",
          url: "/ar/aihyper-architecture/"
        },
        {
          text: "من نحن",
          url: "/ar/our-company/"
        }
      ]
    },
    {
      links: [
        {
          text: "الابتكار المشترك والمشاركة المشتركة لفا‌رادي فيوتشر",
          url: "/ar/ff-co-creation-and-co-sharing/"
        },
        {
          text: "الموقع والفعاليات‌",
          url: "/ar/live-and-events/"
        },
        {
          text: "علاقات المستثمرين",
          url: "https://investors.ff.com/"
        }
      ]
    }
  ],
  extraLinks: [],
  regionsV4: [
    {
      country: "United States",
      code: "US",
      language: "English",
      url: "https://www.ff.com/us/"
    },
    {
      country: "中国大陆",
      code: "CN",
      language: "简体中文",
      url: "https://www.faradayfuturecn.com/cn/"
    },
    {
      code: "AR",
      url: "https://www.ff.com/ar/",
      country: "UAE(اَلْعَرَبِيَّةُ)",
      language: "اَلْعَرَبِيَّةُ"
    },
    {
      code: "AR_EN",
      url: "https://www.ff.com/ar/en/",
      country: "UAE(English)",
      language: "English"
    }
  ],
  version: "4"
};

export default usFooterProps;
export { aeEnFooterProps, aeArFooterProps };
